var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-menu"},[_c('div',{staticClass:"user-menu-item",on:{"click":_vm.signout}},[_vm._v("Signout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }